import React, { useState } from "react";
import * as Yup from "yup";
import { Formik } from "formik";

import FormikFormLine from "../formik-form-components/FormikFormLine";
import Button from "../common/Button";
import FormValidationError from "../common/FormValidationError";

import { PageTitle } from "../../constants/Styles";
import { NEWSLETTER_SIGNUP_PAGE_SOURCE } from "../../constants/marketing";
import { EMAIL_SCHEMA } from "../../utils/forms";
import { FieldTypes } from "../formik-form-components/FormikFormLine/constants";
import { ButtonTypes } from "../common/Button/constants";
import { MARKETING_SIGN_UP_TEXT } from "../../constants/marketing";
import { SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER } from "../../constants/errors";
import * as styledElements from "./NewsletterStyles";
import {
  SignUpFormValues,
  useEmailMarketingSignUp,
} from "../../utils/hooks/emailMarketingSignUp";

const schema = Yup.object().shape({
  firstName: Yup.string(),
  lastName: Yup.string(),
  email: EMAIL_SCHEMA,
});

const FORM_INFO = [
  {
    name: "firstName",
    label: "First name",
    isRequired: false,
  },
  {
    name: "lastName",
    label: "Last name",
    isRequired: false,
  },
  {
    name: "email",
    label: "Email",
    type: FieldTypes.email,
    isRequired: true,
  },
];

export default function Newsletter({ source }: { source?: string }) {
  const [submitted, setSubmitted] = useState(false);
  const onSuccess = () => {
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 2000);
  };
  const { signUp, errored, validationError, loading } = useEmailMarketingSignUp(
    { onSuccess },
  );

  const initialValues: SignUpFormValues = {
    firstName: "",
    lastName: "",
    email: "",
    source: source || NEWSLETTER_SIGNUP_PAGE_SOURCE,
  };

  return (
    <styledElements.Container>
      <PageTitle>FlashPCB Newsletter</PageTitle>
      <styledElements.Description>
        Sign up to get $100 off your first order over $200.
        <styledElements.FinePrint>
          Valid on first-time email address submissions only.
        </styledElements.FinePrint>
      </styledElements.Description>
      <styledElements.Content>
        <Formik
          initialValues={initialValues}
          onSubmit={signUp}
          validationSchema={schema}
        >
          {({ handleSubmit, isValid, dirty }) => (
            <styledElements.Form onSubmit={handleSubmit}>
              {FORM_INFO.map((formLine) => (
                <FormikFormLine
                  key={formLine.name}
                  name={formLine.name}
                  type={formLine.type}
                  label={formLine.label}
                  isRequired={formLine.isRequired}
                />
              ))}
              <styledElements.MarketingInfo>
                {MARKETING_SIGN_UP_TEXT}
              </styledElements.MarketingInfo>
              <Button
                label={"Sign up"}
                type={ButtonTypes.SUBMIT}
                disabled={!(isValid && dirty) || loading}
                centerText
              />
            </styledElements.Form>
          )}
        </Formik>
        <styledElements.Info>
          {submitted && <p>Thanks!</p>}
          {validationError && (
            <FormValidationError validationMessage={validationError} />
          )}
          {errored && (
            <FormValidationError
              validationMessage={SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER}
            />
          )}
        </styledElements.Info>
      </styledElements.Content>
    </styledElements.Container>
  );
}
